import {useEffect, useRef, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import axiApi from "ApiCaller";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import {publishEvent} from "core/eventsConnector";

const ModalSelectPlatformUser = ({show, setShow}) => {
    const items = useRef({
        all: [],
        showed: [],
        chosen: null,
    });

    const [itemsShow, setItemsShow] = useState([]);
    const [checked, setChecked] = useState(null);

    useEffect(() => {
        if (show) {
            axiApi.get("/api/telegram/users/available-users/").then((resp) => {
                const list = resp.data.items || [];
                items.current.all = [...list];
                items.current.showed = [...list];
                items.current.chosen = null;
                setChecked(null);
                setItemsShow([...list]);
            }).catch(() => {
                items.current.all = [];
                items.current.showed = [];
                setItemsShow([]);
            });
        }
    }, [show]);

    const onSearch = (e) => {
        const valueSearched = toLowCaseCleanSpaces(e.target.value);
        if (valueSearched) {
            const filter_ = items.current.all.filter(
                (it) =>
                    toLowCaseCleanSpaces(it.email).includes(valueSearched) ||
                    toLowCaseCleanSpaces(it.first_name || "").includes(valueSearched) ||
                    toLowCaseCleanSpaces(it.last_name || "").includes(valueSearched)
            );
            items.current.showed = [...filter_];
        } else {
            items.current.showed = [...items.current.all];
        }
        setItemsShow([...items.current.showed]);
    };

    const handleClose = () => {
        setShow(false);
    };

    const handleAccept = () => {
        setShow(false);
        const selected = items.current.chosen
            ? items.current.all.find((it) => it.id === items.current.chosen)
            : null;

        publishEvent("telegram:modalselect:change", selected);
    };

    const toggleCheck = (id) => {
        items.current.chosen = id;
        setChecked(id);
    };

    return (
        <Modal show={show} onHide={handleClose} animation={true} dialogClassName="modal-dialog-scrollable">
            <Modal.Header closeButton className="preview-canvas mb-0">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="user"/>
                </div>
                <div className="preview-title d-inline-flex align-items-center">
                    <Modal.Title className="d-inline-flex ms-1">
                        <div>
                            <div className="h4 ms-0">
                                Usuarios:
                            </div>
                            <div className="h5 ms-0">
                                <small>Selecciona para vincular</small>
                            </div>
                        </div>
                    </Modal.Title>
                    <form className="d-inline-flex ms-2" role="search" onSubmit={(e) => e.preventDefault()}>
                        <input className="form-control border-end-0 rounded-0" type="search"
                               placeholder="Buscar"
                               aria-label="Search"
                               onChange={onSearch}
                        />
                        <span className="input-group-text bg-white border-start-0 rounded-0">
                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass"/>
                        </span>
                    </form>
                </div>
            </Modal.Header>
            <Modal.Body>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th style={{width: "30px"}}></th>
                        <th>Email</th>
                        <th>Nombre</th>
                    </tr>
                    </thead>
                    <tbody>
                    {itemsShow.length === 0 && (
                        <tr>
                            <td colSpan="3" className="text-center text-muted fst-italic">
                                No hay usuarios disponibles
                            </td>
                        </tr>
                    )}
                    {itemsShow.map((item, index) => (
                        <tr key={index}
                            className="cursor-pointer"
                            onClick={() => toggleCheck(item.id)}
                            style={{cursor: "pointer"}}>
                            <td>
                                <input type="radio" name="selectPlatformUser"
                                       checked={checked === item.id}
                                       onChange={() => toggleCheck(item.id)}
                                       onClick={(e) => e.stopPropagation()}
                                />
                            </td>
                            <td>{item.email}</td>
                            <td>{[item.first_name, item.last_name].filter(Boolean).join(" ") || "—"}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleAccept} disabled={!checked}>
                    Seleccionar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalSelectPlatformUser;
